import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TypeLoading } from '@app/enums';
import { LoadingService } from '@app/services/loading.service';
import { AmCalendarComponent } from '@app/shared/modals/am-calendar/am-calendar.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Moment } from 'moment';

/**
 * Componente de botón para abrir un calendario modal.
 * Permite la selección de una fecha y emite un evento con la fecha seleccionada.
 */
@Component({
    selector: 'am-button-calendar',
    templateUrl: './am-button-calendar.component.html',
    styleUrls: ['./am-button-calendar.component.scss'],
    standalone: false
})
export class AmButtonCalendarComponent implements OnInit {

 
  /**
   * Fecha seleccionada.
   */
  dateSelected = null;

  /**
   * Fecha de inicio predefinida.
   */
  @Input() dayInit: Moment;

  /**
   * Indica si el botón debe ocupar todo el ancho disponible.
   */
  @Input() fullSize: boolean = false;

  /**
   * Evento que emite la fecha seleccionada en el calendario.
   */
  @Output() selected: EventEmitter<any> = new EventEmitter();

  constructor(
    private modalService: NgbModal,
    private _loadingService: LoadingService
  ) { }

  ngOnInit() {
    this.dateSelected = this.dateSelected ?? this.dayInit;
  }
 /**
   * Abre el modal del calendario y maneja la selección de fecha.
   */
  handleCalendar() {
    const modalRef = this.modalService.open(AmCalendarComponent,
      {
        centered: true,
        size: 'lg',
        backdrop : 'static',
        keyboard : false,
        windowClass: 'Calendar-modal'
      });

    modalRef.componentInstance.daySelected = this.dateSelected;

    modalRef.result.then((value)=> {
      if (value) {
        const { date } = value;
        this.dateSelected = date;
        this.selected.emit(this.dateSelected);
      }    
    });

    this._loadingService.hideLoading(TypeLoading.FOOTER_LOADING);
  }

}
